// extracted by mini-css-extract-plugin
module.exports = {"table-heading":"yckNL","tableHeading":"yckNL","light":"_3nU1w"};